import { useCallback, useEffect, useRef, useState } from 'react'

export function debouncedCallback(func, delay, timeoutStorage = undefined) {
  let timeoutId = null

  return (...args) => {
    clearTimeout(timeoutId)
    if (timeoutStorage) {
      timeoutStorage.timeoutId = null
    }

    timeoutId = setTimeout(() => {
      clearTimeout(timeoutId)
      if (timeoutStorage) {
        timeoutStorage.timeoutId = null
      }
      func(...args)
    }, delay)
    if (timeoutStorage) {
      timeoutStorage.timeoutId = timeoutId
    }
  }
}

export function useDebouncedCallback(func, delay) {
  const timeout = useRef()

  return useCallback(
    (...args) => {
      const later = () => {
        clearTimeout(timeout.current)
        func(...args)
      }

      clearTimeout(timeout.current)
      timeout.current = setTimeout(later, delay)
    },
    [func, delay]
  )
}

export function useDebouncedValue(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [value, delay])

  return debouncedValue
}
